import { render, staticRenderFns } from "./CurrentDecursus.vue?vue&type=template&id=a877cd30"
import script from "./CurrentDecursus.vue?vue&type=script&lang=js"
export * from "./CurrentDecursus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports